import { register } from 'timeago.js'

function itLocale(number, index, totalSec) {
	return [
		['Poco fa', 'fra poco'], // 1 sec
		['Poco fa', 'fra poco'], // 2-59 sec
		['Poco fa', 'fra poco'], // 1 min
		['%s minuti fa', 'fra %s minuti'], // 2-59 min
		['1 ora fa', 'fra 1 ora'], // 1h
		['%s ore fa', 'fra %s ore'], // 2-24h
		['1 giorno fa', 'fra 1 giorno'], // 1 day
		['%s giorni fa', 'fra %s giorni'], // 2-29 days
		['1 sett. fa', 'fra 1 sett'], // 1 week, use abbreviated form
		['%s sett. fa', 'fra %s sett'], // 2-3 weeks
		['1 mese fa', 'fra 1 mese'], // 1 month
		['%s mesi fa', 'fra %s mesi'], // 2-11 months
		['1 anno fa', 'fra 1 anno'], // 1 year
		['%s anni fa', 'fra %s anni'], // 2+ years
	][index]
}

register('itLocale', itLocale)

export default itLocale
